export default __webpack_public_path__ + "static/media/jobs-logo.e72b094d.svg";